import { Component, OnInit, ViewEncapsulation, Input, AfterViewInit, Output, ElementRef } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class ListComponent implements OnInit, AfterViewInit {

  /** Define, it this list allows multiple item selection at the same time. */
  @Input() multiSelection = false;
  @Input() set selected(entry: any) {
    this.selections.select(entry);
  }
  /** Helper to handle the currently selected items. Type 'any', because model is not known */
  @Output() selections: SelectionModel<any> = new SelectionModel(this.multiSelection);

  private self: ElementRef;

  constructor(self: ElementRef) {
    this.self = self;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }
}
